import {useWikiStore} from "~/store/wiki"

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('store-focus', storeFocus)
})

const storeFocus = {
    mounted: function (el, binding) {
        el.storeFocusEvent = function () {
            useWikiStore().anchor = binding.value ?? null
        }
        el.addEventListener('focusin', el.storeFocusEvent)
    },
    unmounted: function (el) {
        el.removeEventListener('focusin', el.storeFocusEvent)
    }
}
